import 'classlist-polyfill'
import 'promise-polyfill/src/polyfill'

import React, { FC, useState, useEffect } from 'react'
import Chart from "react-apexcharts"
import { useTranslation } from 'react-i18next'

import Loading from '../common/Loading'

import { chartOptions as initialChartOptions } from './VariablesMixChart'

import { MemberReportMixChart } from '../../../states/types/member'

interface MixChartProps {
  isLoading: boolean | undefined
  mixChart: MemberReportMixChart | undefined
}

const MixChart: FC<MixChartProps> = (props) => {
  const { t } = useTranslation()

  const {
    isLoading,
    mixChart,
  } = props

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [chartData, setChartData] = useState<any>(undefined)

  useEffect(() => {
    if (!mixChart) {
      setChartData(undefined)
      return
    }

    const chartOptions = initialChartOptions
    chartOptions.xaxis.categories = mixChart.label.days
    chartOptions.xaxis.labels.style.colors = mixChart.label.color

    setChartData({
      option: {
        ...chartOptions,
        xaxis: {
          ...chartOptions.xaxis,
        },
      },
      series: [{
        name: "作業時間",
        type: 'column',
        data: mixChart.active_time,
      }, {
        name: "操作量",
        type: 'line',
        data: mixChart.biz_point,
      }],
    })
  }, [mixChart])

  return (
    <div style={{ marginLeft: "0.5em", marginRight: "0.5em" }}>
      <div className="box">
        {
          (isLoading || !chartData) ? (
            <Loading />
          ) : (
            <>
              <Chart
                options={chartData.option}
                type="line"
                series={chartData.series}
                height="350px"
              />
            </>
          )
        }
      </div>
    </div>
  )
}

export default MixChart
